var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrowdstrike = function SvgCrowdstrike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FC0000",
    clipPath: "url(#crowdstrike_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.633 16c-.545-1.247-1.639-2.846-5.924-5.13C7.733 9.77 4.356 8.08 1.321 4.862c.275 1.16 1.685 3.711 7.748 6.894 1.68.919 4.52 1.78 6.564 4.24M15.36 13.866c-.516-1.473-1.45-3.36-5.876-6.16C7.328 6.294 4.163 4.521 0 0c.298 1.219 1.614 4.388 8.246 8.503 2.18 1.477 4.991 2.387 7.114 5.363"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "crowdstrike_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgCrowdstrike;